var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FloatingCard',{attrs:{"feeling":_vm.feeling}},[_c('ContainersList',{attrs:{"token":_vm.token,"roomID":_vm.roomID,"name":"import"},on:{"status-change":_vm.updateStatus,"container-change":_vm.updateSelectedContainer}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }